"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormattedMessage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _translationsNamespaceContext = require("../contexts/TranslationsNamespaceProvider/translationsNamespaceContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
}
/**
 * Props for the FormattedMessage component.
 *
 * @template T - The type of translations.
 * @template V - The type of values for message formatting.
 */ /**
 * Renders a formatted internationalized message using the provided translation data.
 * @remarks Use in case of translation with HTML components instead of formatMessage accessible from useTranslations hook
 *
 * @template T The type of the translation data.
 *
 * @example
 * // Basic usage
 * <FormattedMessage<DefaultTranslations> id="greeting" />
 *
 * @description
 * This component is used for rendering internationalized messages. It combines the provided `id` with
 * the current translation namespace to retrieve the corresponding translation message.
 *
 * @see {@link FormattedMessageProps} for the available props and options.
 */ var FormattedMessage = function(_param) {
    var id = _param.id, props = _object_without_properties(_param, [
        "id"
    ]);
    var namespace = (0, _react.useContext)(_translationsNamespaceContext.translationsNamespaceContext).namespace;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, _object_spread({
        id: "".concat(namespace, ":").concat(String(id))
    }, props));
};
exports.FormattedMessage = FormattedMessage; //# sourceMappingURL=FormattedMessage.js.map
